import { Form, Modal } from "react-bootstrap";
import "./Alert_Modal.css";
import Alert_Lottie from "../../../animation/alert_lottie/Alert_Lottie";
import Green_Btn from "../../common_btn/green_btn/Green_Btn";
import { useNavigate } from "react-router-dom";

const Alert_Modal = ({ data, ...props }) => {
  const navigate = useNavigate();

  return (
    <Modal {...props} className="Alert_Modal" size="lg" centered>
      <div className="absolute_div">
        <div className="animation_holder">
          <Alert_Lottie />
        </div>
      </div>
      <Modal.Body>
        <div className="content_div">
          <p className="black_text">Please make sure... fdf</p>

          <div className="note_div">
            <img
              src="/assets/images/icons/red_alert.png"
              className="alert_img"
            />
            <p className="alert_text">
              You are above 18 years of age and not buying {data?.name} on
              behalf of anyone who is a minor (under 18 years of age.)
            </p>
          </div>

          <div className="note_div">
            <img
              src="/assets/images/icons/red_alert.png"
              className="alert_img"
            />
            <p className="alert_text">
              Your location is not in and around a school or college premises.
            </p>
          </div>

          <div className="note_div green_note">
            <img
              src="/assets/images/icons/green_alert.png"
              className="alert_img"
            />
            <p className="alert_dark_text">
              We are bound to report your account in case of any transgressions!
            </p>
          </div>

          <p
            className="footer_link_text"
            onClick={() => navigate("/terms-conditions")}
          >
            Read our terms and conditions
          </p>

          <div className="btn_holder">
            <Green_Btn
              btn_name="Yes, I'm above 18"
              onClick={() => navigate(props.url)}
            />
            <p
              className="link_text_holder"
              onClick={props.onHide} // <-- closes modal
            >
              No, I'm below 18
            </p>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Alert_Modal;
